export default __webpack_public_path__ + "static/img/lens-arrow.e5f354b.svg";